<template>
    
  <div v-if="skin_charged" style="color:white;position:relative;overflow: hidden;">
    <div>
        <main-header
        v-if="screen_width>selected_skin.break_point"
        v-bind:skin="selected_skin"
        v-bind:language="language"
        v-bind:translation="translation"
        />
        <div v-else class="fixed-top">
            <main-header-mobil
                v-bind:skin="selected_skin"
                v-bind:language="language"
                v-bind:translation="translation"
            />
        </div>
        <div v-if="screen_width<selected_skin.break_point" :style="'height:'+headerHeight"></div>
        <div v-if="screen_width<selected_skin.break_point && view == 'main'">
            <div class="d-flex p-2" :style="selected_skin.navigation_bar.frame" style="position: relative;">
                <span @click="change_mobile_view('main')" class="mx-3" :style="lobbyView=='main'?selected_skin.menu_sports.selected_view:''">{{translate("home")}}</span>
                <span @click="change_mobile_view('live')" class="mx-3" :style="lobbyView=='sport'&&mobile_selected_type=='live'?selected_skin.menu_sports.selected_view:''">{{translate("live")}}</span>
                <span @click="change_mobile_view('prematch')" class="mx-3" :style="lobbyView=='sport'&&mobile_selected_type=='prematch'?selected_skin.menu_sports.selected_view:''">{{translate("DEPORTES")}}</span>
                <span class="ml-auto" :style="selected_skin.search.icon" style="top: 40%; transform: translateX(-5%);" @click="toggleSearchInput"><i class="fas fa-search"></i></span>
            </div>
            <menu-sports
                v-if="render && view == 'main' && lobbyView!='prematch2_evento' && lobbyView!='live' && !showInput"
                v-bind:skin="selected_skin"
                v-bind:language="language"
                v-bind:translation="translation"
                v-bind:sports_data="mobile_selected_type=='prematch'?sports_prematch:sports_live"
            ></menu-sports>
        </div>
        <div v-if="view == 'main'" class="row g-0">
            <div v-if="screen_width>selected_skin.break_point" class="col-lg-2 col-md col-sm " :style="(screen_width<selected_skin.break_point?'':'height:'+contentHeight+'; overflow: auto;width:14%;')+selected_skin.fondo0">
                <main-search
                    v-bind:skin="selected_skin"
                    v-bind:language="language"
                    v-bind:translation="translation"
                ></main-search>
                <ul class="nav px-1" id="sportsTabs" role="tablist">
                    <li class="nav-item text-center py-2" role="presentation" :style="activeTab=='prematch'?selected_skin.menu_prematch.tab_selected:selected_skin.menu_prematch.tab_normal">
                        <span @click="activeTab='prematch'" style="width: 100%;" :class="lobbyView !== 'live' ? 'active' : ''" id="tabPrematch" data-bs-toggle="pill" data-bs-target="#tab-prematch" type="button" role="tab" aria-controls="tab-prematch" aria-selected="true">{{ translate('prematch') }}</span>
                    </li>
                    <li class="nav-item text-center py-2" role="presentation" :style="activeTab=='live'?selected_skin.menu_live.tab_selected:selected_skin.menu_live.tab_normal">
                        <span @click="activeTab='live'" style="width: 100%;" :class="lobbyView === 'live' ? 'active' : ''" id="tabLive" data-bs-toggle="pill" data-bs-target="#tab-live" type="button" role="tab" aria-controls="tab-live" aria-selected="false">{{ translate('live') }}</span>
                    </li>
                </ul>
                <div class="tab-content px-1" id="sportTabs-tabContent">
                    <div class="tab-pane fade" :class="lobbyView !== 'live' ? 'show active' : ''" id="tab-prematch" role="tabpanel" aria-labelledby="tabPrematch">
                        <div style="overflow:hidden">
                            <div v-if="prematchTarget==0">
                                <schedule
                                    v-bind:skin="selected_skin"
                                    v-bind:language="language"
                                    v-bind:translation="translation"
                                />
                                <div v-if="!timeLoading" :style="selected_skin.menu_prematch.body">
                                    <mainLigas3
                                        v-bind:skin="selected_skin"
                                        v-bind:language="language"
                                        v-bind:translation="translation"
                                    >
                                    </mainLigas3>
                                    <eventoDeportePrematch
                                    v-for="(deporte, idx) in sports_prematch"
                                    v-bind:deporte="deporte"
                                    v-bind:Skin="selected_skin"
                                    v-bind:key="idx"
                                    v-bind:language="language"
                                    v-bind:translation="translation"
                                    >
                                    </eventoDeportePrematch>  
                                </div>
                                <div v-else class="text-center py-5">
                                    <div class="spinner-border" :style="selected_skin.loader" role="status">
                                        <span class="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" :class="lobbyView === 'live' ? 'show active' : ''" id="tab-live" role="tabpanel" aria-labelledby="tabLive">
                        <div class="m-1 mb-2" :style="selected_skin.menu_live.body" style="overflow:hidden">
                            <favoritoLive v-if="favoritos.length > 0"
                                v-bind:favoritos="favoritos"
                                v-bind:Skin="selected_skin"
                                v-bind:language="language"
                                v-bind:translation="translation"
                                >
                            </favoritoLive>
                            <eventoDeporteLive
                                v-for="(deporte, idx) in sports_live"
                                v-bind:deporte="deporte"
                                v-bind:Skin="selected_skin"
                                v-bind:key="idx"
                                v-bind:language="language"
                                v-bind:translation="translation"
                                >
                            </eventoDeporteLive>
                        </div>
                    </div>
                </div>
            </div>
            <main-search2
                v-if="showInput"
                v-bind:skin="selected_skin"
                v-bind:language="language"
                v-bind:translation="translation">
            </main-search2>
            <div id="events_data" class="col-lg-8 col-md col-sm p-0" :style="(screen_width<selected_skin.break_point?'overflow-x: hidden;':'height:'+contentHeight+'; overflow-x: hidden; overflow-y:auto;width:61%;')+selected_skin.fondo0">
                <!-- Lobby -->
                <div v-if="lobbyView=='main'">
                    <main-ligas-2
                        v-if="screen_width>selected_skin.break_point"
                        v-bind:skin="selected_skin"
                        v-bind:language="language"
                        v-bind:translation="translation"
                    />
                    <div v-if="lobbyView=='prematch2_ligas2'">
                        <ligas-prematch-2
                            v-bind:skin="selected_skin"
                            v-bind:language="language"
                            v-bind:translation="translation"
                        ></ligas-prematch-2>
                    </div>
                    <lobby
                        v-bind:skin="selected_skin"
                        v-bind:language="language"
                        v-bind:translation="translation"
                        v-bind:time="time"
                    ></lobby>
                </div>
                <div v-if="lobbyView == 'live'">
                    <div v-if="!target_event_loaded" :style="screen_width<selected_skin.break_point?'':'width:100%; height:'+contentHeight+';'" class="text-center py-5">
                        <div class="spinner-border text-warning" role="status">
                        <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                    <animation
                        v-if="game && screen_width<selected_skin.break_point && target_event_loaded"
                        v-bind:Skin="selected_skin"
                        v-bind:language="language"
                        v-bind:translation="translation"
                    />
                    <encuentroData
                        v-if="target_event_loaded"
                        v-bind:Skin="selected_skin"
                        v-bind:language="language"
                        v-bind:translation="translation"
                    ></encuentroData>
                </div>
                <!-- Ligas Prematch -->
                <div v-if="lobbyView=='prematch2_ligas'">
                    <ligas-prematch-2
                        v-bind:skin="selected_skin"
                        v-bind:language="language"
                        v-bind:translation="translation"
                    ></ligas-prematch-2>
                </div>
                <!-- Prematch Evento -->
                <div v-if="lobbyView=='prematch_event' && Object.keys(prematch_evento_data).length > 0">
                    <prematch-encuentro
                        v-bind:liga="prematch_evento_data.data"
                        v-bind:skin="selected_skin"
                        v-bind:sport="prematch_evento_data.data.deporte.id"
                        v-bind:time="time"
                        v-bind:language="language"
                        v-bind:translation="translation"
                        v-bind:search="{encuentro:prematch_evento_data.id}"
                    />
                </div>
                <div v-if="lobbyView=='prematch2_evento'">
                    <prematch-2-encuentro
                        v-bind:Skin="selected_skin"
                        v-bind:language="language"
                        v-bind:translation="translation"
                        v-bind:gameData="prematch2_gameData"
                    />
                </div>
                <!-- Ligas Live -->
                <div v-if="lobbyView=='live_ligas'">
                    <ligas-live
                        v-bind:skin="selected_skin"
                        v-bind:language="language"
                        v-bind:translation="translation"
                    />
                </div>
                <!-- Deportes -->
                <div v-if="lobbyView=='sport' && screen_width<selected_skin.break_point">
                    <div v-if="mobile_selected_type=='prematch'">
                        <schedule
                            v-bind:skin="selected_skin"
                            v-bind:language="language"
                            v-bind:translation="translation"
                        />
                        <mainLigas3
                            v-bind:skin="selected_skin"
                            v-bind:language="language"
                            v-bind:translation="translation"
                            v-bind:sport="sport_selected.id_live"
                        >
                        </mainLigas3>
                        <div :id="'d-prematch2'+ sport_selected.id_live" class="accordion-collapse"  aria-labelledby="headingOne" :data-bs-parent="'#acordion-prematch2'+ sport_selected.id_live">
                            <div class="accordion-body p-0" :style="selected_skin.menu_prematch.accordion_fondo">
                            <evento-pais-prematch
                                    v-for="(pais) in regiones"
                                    v-bind:region="pais"
                                    v-bind:deporte="{id:sport_selected.id_live,name:sport_selected.name}"
                                    v-bind:skin="selected_skin"
                                    v-bind:key="pais.id"
                                    >
                            </evento-pais-prematch>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="mobile_selected_type=='live'">
                        <div :id="'d-live'+ sport_selected.id_live" class="accordion-collapse"  aria-labelledby="headingOne" :data-bs-parent="'#acordion-live'+ sport_selected.id_live">
                            <div class="accordion-body p-0" :style="selected_skin.menu_live.accordion_fondo">
                                <eventoPaisLive
                                        v-for="(pais) in regiones"
                                        v-bind:region="pais"
                                        v-bind:deporte="{id:sport_selected.id_live,name:sport_selected.name}"
                                        v-bind:skin="selected_skin"
                                        v-bind:key="pais.id"
                                        >
                                </eventoPaisLive>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="screen_width<selected_skin.break_point">
                    <qbet v-bind:skin="selected_skin"
                        v-bind:language="language"
                        v-bind:translation="translation"
                    />
                </div>
            </div>
            <div  class="col-lg-2 col-md-2 d-none d-lg-block" :style="(screen_width<selected_skin.break_point?'':'height:'+contentHeight+'; overflow:auto;width:25%;position:relative;')+selected_skin.fondo0">
                <animation
                    v-if="game && screen_width>selected_skin.break_point"
                    v-bind:Skin="selected_skin"
                    v-bind:language="language"
                    v-bind:translation="translation"
                >
                </animation>
                <qbet
                    v-bind:skin="selected_skin"
                    v-bind:language="language"
                    v-bind:translation="translation"
                ></qbet>
                <div class="d-flex" v-if="selected_skin.banners.qbet_vertical.enabled">
                    <div v-if="screen_width>450" style="width:100%;position:relative;height:800px">
                        <!-- Carrousel Vertical -->
                        <iframe :src="selected_skin.banners.qbet_vertical.url"  frameborder="0" style="width:100%;position:relative;height:800px"></iframe>
                    </div>
                </div>
                <div v-if="debug" class="p-2">
                    <input v-model="follow_id" type="text" placeholder="event id"><button @click="follow">Seguir evento</button>
                    <button @click="set_bets()">{{ can_bet?'Desactivar Apuestas':'Activar Apuestas' }}</button>
                    <button @click="close_socket()">Cerrar Socket</button>
                </div>
            </div>
        </div>
        <div v-if="view == 'casino_live'" class="py-0">
            <div v-if="selected_skin.casinoLive_config?.provider=='jbets'" class="holds-the-iframe" :style="'height:'+contentHeight+';'">
                <iframe allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" :style="'height:'+contentHeight+';'" class="iframeStyle" ref="casino_frame" :src="casino_frame!=''?casino_frame:selected_skin.casinolive_lobby?.lobby_url ?? ''" frameborder="0"></iframe>
            </div>
        </div>
        <div v-if="view == 'crazzyWin'" class="py-0"> 
            <div v-if="selected_skin.crazzywin_config?.provider=='jbets'" class="holds-the-iframe" :style="'height:'+contentHeight+';'">
                <iframe allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" :style="'height:'+contentHeight+';'" class="iframeStyle" ref="casino_frame" :src="selected_skin.crazzywin_config.url+'&token='+user.token+user.site_id+'-'+user.site+'&playerId='+user.user_data.data.id+'_'+user.site_id+'&language='+language+'&currency='+user.user_data.data.currency" frameborder="0"></iframe>
            </div>
        </div>
        <div v-if="view == 'bingo'" class="py-0">
            <div v-if="selected_skin.bingo_config?.provider=='jbets'" class="holds-the-iframe" :style="'height:'+contentHeight+';'">
                <iframe allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" :style="'height:'+contentHeight+';'" class="iframeStyle" ref="casino_frame" :src="selected_skin.bingo_config.url+'&token='+user.token+user.site_id+'-'+user.site+'&playerId='+user.user_data.data.id+'_'+user.site_id+'&language='+language+'&currency='+user.user_data.data.currency" frameborder="0"></iframe>
            </div>
        </div>
        <div v-if="view == 'hipicas'" class="py-0">
            <div v-if="selected_skin.hipicas_config?.provider=='jbets'" class="holds-the-iframe" :style="'height:'+contentHeight+';'">
                <iframe allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" :style="'height:'+contentHeight+';'" class="iframeStyle" ref="casino_frame" :src="selected_skin.hipicas_config.url+'&token='+user.token+user.site_id+'-'+user.site+'&playerId='+user.user_data.data.id+'_'+user.site_id+'&language='+language+'&currency='+user.user_data.data.currency" frameborder="0"></iframe>
            </div>
            <div v-else class="holds-the-iframe" :style="'height:'+contentHeight+';'">
                <iframe allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" :style="'height:'+contentHeight+';'" class="iframeStyle" ref="casino_frame" 
                :src="config.SkinCConfig.racing.horse.url+'?tokenUser='+user.token+user.site_id+'&tokenClient=72b0fc93-fdd1-4c08-b1fd-0be81726a5d2&lang=es&cashierUrl='+user.domain+'&homeUrl='+user.domain" frameborder="0"></iframe>
            </div>
        </div>
        <div v-if="view == 'casino'" class="py-0">
            <div id="casinoViewContainer" v-if="selected_skin.casinoN_config?.provider=='jbets'" class="holds-the-iframe" :style="'height:'+contentHeight+';'">
                <iframe id="casinoViewIframe" allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" :style="'height:'+contentHeight+';'" class="iframeStyle" ref="casino_frame" :src="selected_skin.casinoN_config.url+'&token='+user.token+user.site_id+'-'+user.site+'&playerId='+user.user_data.data.id+'_'+user.site_id+'&language='+language+'&currency='+user.user_data.data.currency" frameborder="0"></iframe>
            </div>
            <div v-else class="p-3" style="background-color:#08142b" :style="'height:'+contentHeight+';'">
                <carousel  
                :paginationEnabled="false"
                :autoplay="false"
                :navigationEnabled="true"
                :navigationNextLabel="next_label"
                :navigationPrevLabel="prev_label"
                :navigationClickTargetSize="0"
                :perPageCustom="[[300, 2],[451, 2],[1024, 7]]"
                class="p-0"
                >
                    <slide v-for="(provider,index) in config.SkinCConfig.providers" :key="index" class="text-center px-1 pe-1">
                        <div :style="selected_skin.casino.button" 
                        :id="index+'-provider'"
                        style="cursor:pointer;"
                        @click="select_casino(provider,index+'-provider')"
                        @mouseover="hover1(index+'-provider')" 
                        @mouseleave="!casino_frame.includes(index+'-provider') ? hover2(index+'-provider') : ''"
                        :class="casino_frame.includes(index+'-provider') ? 'hover' : ''">
                            <span style="font-size:small;">{{ provider.name.toUpperCase() }}</span>
                        </div>
                    </slide>
                </carousel>
                <div class="holds-the-iframe">
                    <iframe :style="'height:'+contentHeight+';'" ref="casino_frame" :src="casino_frame != '' ? (casino_frame != 'loading' ? casino_frame : '') : user.domain+'/casino/casino25/pragmatic?token='+user.token" frameborder="0"></iframe>
                </div>
            </div>
        </div>
        <div v-if="view == 'poker'">
            <div class="holds-the-iframe">
                <iframe :style="'height:'+contentHeight+';'" :src="user.domain+'/casino/poker/'+user.token+'/lobby?token='+user.token" frameborder="0"></iframe>
            </div>
        </div>
        <div v-if="view == 'results'">
            <div class="holds-the-iframe">
                <iframe :style="'height:'+contentHeight+';'" :src="'https://d.fichadorada.bet/#/results/?lang='+selected_skin.languages[language].code" frameborder="0"></iframe>
            </div>
        </div>
        <div v-if="view == 'lobby' && selected_skin.front_lobby.enabled">
            <div class="holds-the-iframe" :style="'height:'+contentHeight+';'">
                <iframe :style="'height:'+contentHeight+';'" :src="selected_skin.front_lobby.url"></iframe>
            </div>
        </div>
    </div>
    <sidebar
        v-if="screen_width<selected_skin.break_point"
        v-bind:language="language"
        v-bind:translation="translation"
    >
    </sidebar>
    <a v-if="selected_skin.whats_app.enabled" :href="'https://api.whatsapp.com/send?phone='+selected_skin.whats_app.phone_number" id="whatsapp_btn" class="float btn" target="_blank" :style="screen_width>selected_skin.break_point?'bottom:20px;right:20px;':'bottom:60px;left:20px;'">
        <img id="whatsapp_logo" class="" src="../../assets/images/whatsappBtn.png" alt="" width="50px">
    </a>
    <div v-if="user.domain!=''">
        <main_records_jm
            v-bind:skin="selected_skin"
            v-bind:language="language"
            v-bind:translation="translation"
            v-bind:user_id="{id:null,nav_bar:true}"
            v-bind:source="'lobby'"
        />
        <support
            v-bind:skin="selected_skin"
            v-bind:language="language"
            v-bind:translation="translation"
            v-bind:type="support_type"
        />
    </div>
    <div v-show="displayModalState != null" class="modal-overlay">
      <game-stats></game-stats>
    </div>
  </div>
</template>

<script>
import eventoPaisPrematch from '../../components/front_ecuabets/main_lobby/main_menu/prematch2/Evento_pais_prematch2.vue';
import eventoPaisLive from '../../components/front_ecuabets/main_lobby/main_menu/live/Evento_pais_live.vue';
import eventoDeporteLive from '../../components/front_ecuabets/live/main_menu/Evento_deporte_live.vue';
import eventoDeportePrematch from '../../components/front_ecuabets/main_lobby/main_menu/prematch2/Evento_deporte_prematch2.vue';
import lobby from '../../components/front_ecuabets/main_lobby/lobby.vue'
import timeLine from '../../components/front_ecuabets/main_lobby/main_menu/prematch1/Time_line_prematch.vue';
import qbet from '../../components/front_ecuabets/main_bet/Qbet.vue';
import menuSports from '../../components/front_ecuabets/main_lobby/main_data/menu_sports.vue';
import mainSearch from '../../components/front_ecuabets/main_lobby/main_data/main_search.vue';
import mainSearch2 from '../../components/front_ecuabets/main_lobby/main_data/main_search_mobile.vue';
import sportView from '../../components/front_ecuabets/main_lobby/main_sport/sport_view.vue';
import ligasPrematch from '../../components/front_ecuabets/prematch/ligas_prematch.vue';
import ligasPrematch2 from '../../components/front_ecuabets/prematch2/ligas_prematch.vue';
import ligasLive from '../../components/front_ecuabets/live/ligas_live.vue';
import prematchEncuentro from '../../components/front_ecuabets/prematch/prematch_encuentro.vue';
import prematch2Encuentro from '../../components/front_ecuabets/prematch2/prematch_encuentro.vue';
import mainHeader from '../../components/front_ecuabets/header/header.vue';
import encuentroData from '../../components/front_ecuabets/live/main_data/Encuentro_data.vue';
import favoritoLive from '../../components/front_ecuabets/live/main_menu/Favorito_live.vue';
import mainHeaderMobil from '../../components/front_ecuabets/header/header_mobil.vue';
import sidebar from '../../components/front_ecuabets/main_lobby/main_menu/Sidebar.vue';
import mainLigas from '../../components/front_ecuabets/main_lobby/main_data/main_ligas.vue';
import mainLigas2 from '../../components/front_ecuabets/main_lobby/main_data/main_ligas2.vue';
import mainLigas3 from '../../components/front_ecuabets/main_lobby/main_data/main_ligas3.vue';
import schedule from '../../components/front_ecuabets/main_lobby/main_menu/schedule.vue';
import main_records_jm from '../../components/front_ecuabets/main_lobby/main_records/main_records_jm.vue';
import animation from '../../components/front_ecuabets/live/animations/Animation.vue';
import GameStats from '../../components/front_ecuabets/main_lobby/main_data/GameStats.vue';
import support from '../../components/front_ecuabets/header/support.vue';
import { Carousel, Slide } from 'vue-carousel';
import router from '../../router/index';
import "/node_modules/flag-icons/css/flag-icons.min.css";
export default {
    name: 'Main',
    components: {
        GameStats,
        eventoDeporteLive,
        eventoDeportePrematch,
        qbet,
        timeLine,
        mainSearch,
        lobby,
        ligasPrematch,
        ligasPrematch2,
        prematchEncuentro,
        prematch2Encuentro,
        ligasLive,
        sportView,
        mainHeader,
        mainHeaderMobil,
        mainSearch2,
        sidebar,
        mainLigas,
        mainLigas2,
        mainLigas3,
        Carousel,
        Slide,
        schedule,
        main_records_jm,
        favoritoLive,
        encuentroData,
        animation,
        menuSports,
        eventoPaisPrematch,
        eventoPaisLive,
        support
    },
    data(){
        return {
            support_type:"newMessge",
            message: "",
            showInput: false,
            activeTab: "prematch",
            sports_loaded: false,
            screen_width:0,
            follow_id:"",
            flag:'es',
            mobile_selected_type:'prematch',
            debug:false,
            prematch_evento_data:{},
            prematch2_gameData:{},
            sport_selected:{},
            casino_frame:"",
            next_label:"<span style='color:white;'>▶</span>",
            prev_label:"<span style='color:white;'>◀</span>",
            refreshHeight: 0,
            casinoUserId: '655d4ae63ad36797f65fabad'
        }
    },
    computed:{
        displayModalState() {
      return this.$store.getters["getDataStatsModal"];
    },
        render(){
            return this.$store.getters['getRenderSportsMenu'];
        },
        game(){
            let self = this;
            let loaded = this.$store.getters['live/getLoadedLiveData'];
            if(Object.keys(this.$store.getters['live/getLiveEvent']).length > 0){
                if(this.$store.getters['live/getLiveEvent'].data){
                    var data = this.$store.getters['live/getLiveEvent'].data.data.sport || {};
                    if(Object.keys(data).length>0){
                        let sport = Object.keys(data)[0];
                        let region_idx = Object.keys(data[sport].region)[0];
                        let league_idx = Object.keys(data[sport].region[region_idx].competition)[0];
                        let game_idx = Object.keys(data[sport].region[region_idx].competition[league_idx].game)[0];
                        if(data[sport].region[region_idx].competition[league_idx].game[game_idx]){
                            if(data[sport].region[region_idx].competition[league_idx].game[game_idx].info){
                                return data[sport].region[region_idx].competition[league_idx].game[game_idx];
                            } 
                        }
                    }
                    if(loaded){const timeout1 = setTimeout(function(){self.$store.dispatch('live/setTargetEvent',1);}, 3000);}
                    return false;
                }
                if(loaded){const timeout1 = setTimeout(function(){self.$store.dispatch('live/setTargetEvent',1);}, 3000);}
                return false;
            }
            if(loaded){const timeout1 = setTimeout(function(){self.$store.dispatch('live/setTargetEvent',1);}, 3000);}
            return false;
        },
        target_event_loaded(){
            return this.$store.getters['live/getLoadedEventData'];
        },
        contentHeight(){
            this.refreshHeight;
            let header_height = this.$store.getters["getHeaderHeight"];
            let screen_height = window.innerHeight;
            return (screen_height - header_height)+"px"; 
        },
        headerHeight(){
            return this.$store.getters["getHeaderHeight"] +"px"
        },
        favoritos(){
            return this.$store.getters['live/getFavorites']; 
        },
        config(){
            return this.$store.getters['getConfig'];
        },
        lobbyView(){
            const data = this.$store.getters['getLobbyView'];
            if (data== 'live') this.activeTab = 'live';
            else { this.activeTab = 'prematch'; }
            return data
        },
        prematchTarget(){
            return this.$store.getters['getPrematchTarget'];
        },
        can_bet(){
            let data = this.$store.getters['getCanBet'];
            return data;
        },
        selected_skin(){
            return this.$store.getters['getCurrentSkin'];
        },
        skin_charged(){
            return this.$store.getters['getSkinCharged'];
        },
        language(){
            return this.$store.getters['getLanguage'];
        },
        sports_live(){
            return  this.$store.getters['live/getSports'];
        },
        sports_prematch(){
            return  this.$store.getters['prematch_2/getSports'];
        },
        favoritos(){
            return this.$store.getters['live/getFavorites']; 
        },
        target_event(){
            if(Object.keys(this.$store.getters['live/getLiveEvent']).length > 0){
                return this.$store.getters['live/getLiveEvent'].data.data.sport;
            }
            return false;
        },
        target_event_loaded(){
            return this.$store.getters['live/getLoadedEventData'];
        },
        translation(){
            return this.$store.getters.getTranslation;
        },
        time(){
            return this.$store.getters['prematch/getTime'];
        },
        timeLoading(){
            return this.$store.getters['prematch_2/getTimeLoading'];
        },
        view(){
            return this.$store.getters["getView"];
        },
        user(){
            let data = this.$store.getters['getUserData'];
            return data;
        },
        bet_counter(){
            let count = 0; 
            let data = this.$store.getters['getBets'];
            Object.keys(data).forEach(element => {
                if(data[element]){
                count++;
                }
            });
            let bar = document.getElementById('navbarToggleExternalContent');
            if(count<1 && bar){
                bar.classList.remove('show');
            }
            return count;
        },
        regiones(){
            let regions = [];
            let data = this.mobile_selected_type == 'prematch' ? this.$store.getters['prematch_2/getSports'] : this.$store.getters['live/getSports'];
            let regions_banned = this.$store.getters['getConfig'].SkinConfig.main.hideRegionsPrematch;
            if(data){
                Object.keys(data).forEach(sport=>{
                    if(data[sport].region && data[sport].id==this.sport_selected.id_live){
                        Object.keys(data[sport].region).forEach(region=>{
                            if(Object.keys(data[sport].region[region]).length>0){
                                if(!regions_banned.includes(data[sport].region[region].alias)){
                                    regions.push(data[sport].region[region]);
                                }
                            }
                        });
                    }
                })
            }
            regions.sort((a,b) => (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0));
            return regions
        },
    },
    created(){
        this.sizeControl();
        let self = this;
        document.addEventListener('keydown', function(event) {
        if (event.ctrlKey && event.key === 'j') {
            self.debug = !self.debug;
        }
        });
        let balanceRequestTime = 60000
        let formated = router.currentRoute.query.target;
        if(formated.includes("-")){
            if(formated.split("-")[2] == 'integration'){
                var saldo_request = setInterval(function(){
                    try {
                        if(self.$store.getters['getUserData'].user_data.data && self.user.token !=""){
                            self.$store.dispatch('getUserData',{
                            token:self.user.token,
                            site_id:self.user.site_id,
                            site:self.user.site,
                            prefix:self.user.prefix,
                            source:"main"
                        });
                        }
                    } catch (error) {
                        clearInterval(saldo_request);
                        this.$store.dispatch('logOut');
                        this.$root.$emit('forceRender');
                    }
                },balanceRequestTime);
            }
        }
    },
    mounted(){
        window.addEventListener('resize', ()=>{this.sizeControl();});
        window.addEventListener("message", (event) => {
            if(event.data.view == 'casino_live'){
                if(this.user.token == ''){
                        this.login();
                }
                else{
                    this.$store.dispatch('setView',event.data.view);
                    this.casino_frame = this.selected_skin.casinolive_lobby?.url ?? ""
                }
            }
            else if(event.data.view == 'bingo'){
                if(this.user.token == ''){
                        this.login();
                }
                else{
                    this.$store.dispatch('setView','bingo');
                    this.casino_frame = this.selected_skin.casinoN_config.url+'?token='+this.user.token+this.user.site_id+'&site='+this.user.site+'&lang='+this.language+'&currency='+this.user.user_data.data.currency+'&view=bingo';
                }
            }
            else if(event.data.view == 'crazywin'){
                if(this.user.token == ''){
                        this.login();
                }
                else{
                    this.$store.dispatch('setView','crazzyWin');
                    this.casino_frame = this.selected_skin.casinoN_config.url+'?token='+this.user.token+this.user.site_id+'&site='+this.user.site+'&lang='+this.language+'&currency='+this.user.user_data.data.currency+'&view=crazzyWin';
                }
            }
            else if(event.data.view == 'casino_live-pragmaticplay'){
                if(this.user.token == ''){
                        this.login();
                }
                else{
                    this.$store.dispatch('setView','casino_live');
                    this.casino_frame = this.selected_skin.casinoLive_config.casino_url+'&token='+this.user.token+this.user.site_id+'-'+this.user.site+'&playerId='+this.user.user_data.data.id+'_'+this.user.site_id+'&language='+this.language+'&currency='+this.user.user_data.data.currency+'&viewId='+this.selected_skin.casinoLive_config.pragmaticLive;
                }
            }
            else if(event.data.view == 'casino_live-ezugi'){
                if(this.user.token == ''){
                        this.login();
                }
                else{
                    this.$store.dispatch('setView','casino_live');
                    this.casino_frame = this.selected_skin.casinoLive_config.casino_url+'&token='+this.user.token+this.user.site_id+'-'+this.user.site+'&playerId='+this.user.user_data.data.id+'_'+this.user.site_id+'&language='+this.language+'&currency='+this.user.user_data.data.currency+'&viewId='+this.selected_skin.casinoLive_config.ezugiLive;
                }
            }
            else if(event.data.view == 'casino_live-vivogaming'){
                if(this.user.token == ''){
                        this.login();
                }
                else{
                    this.$store.dispatch('setView','casino_live');
                    this.casino_frame = this.selected_skin.casinoLive_config.casino_url+'&token='+this.user.token+this.user.site_id+'-'+this.user.site+'&playerId='+this.user.user_data.data.id+'_'+this.user.site_id+'&language='+this.language+'&currency='+this.user.user_data.data.currency+'&viewId='+this.selected_skin.casinoLive_config.vivogamingLive;
                }
            }
            else if(event.data.view == 'hipicas'){
                if(this.user.token == ''){
                        this.login();
                }
                else{
                    this.$store.dispatch('setView','hipicas');
                }
            }
            else if(event.data.view == 'main'){
                this.$store.dispatch('setLobbyView',event.data.view);
                this.$store.dispatch('setView',event.data.view);
            }
            else if(event.data.view == 'register'){
                this.register();
            }
            else if(event.data.view == 'poker'){
                if(this.user.token == ''){
                        this.login();
                }
                else{
                    this.$store.dispatch('setView',event.data.view);
                }
            }
            else if(event.data.view == 'casino'){
                if(this.user.token == ''){
                    this.login();
                }
                else{
                    this.$store.dispatch('setView',event.data.view);
                    const iframe = document.getElementById("casinoViewIframe")
                    if(iframe){
                        const alturaContenido = iframe.contentWindow.document.body.scrollHeight;
                        iframe.style.height = alturaContenido + 'px';
                    }
                }
            }
        }, false);
        this.$root.$on('show_prematch_ligas', (type) => {
            if(type==1){
                this.$store.dispatch('prematch/delete_all_ligas');
            }
        });
        this.$root.$on('select_sport', (data) => {
            this.sport_selected=data;
        });
        this.$root.$on('set_prematch_event', (data) => {
            this.prematch_evento_data = {data:data.data,id:data.id};
        });
        this.$root.$on('show_prematch2_event', (data) => {
            this.prematch2_gameData= data;
        });
        this.$root.$on('reset_search', (data) => {
            this.showInput= data;
        });
        this.$root.$on('openSupportModal', (data) => {
            this.support_type = data;
        });
    },
    methods:{
        toggleSearchInput() {
            // console.log(this.showInput)
            this.showInput = !this.showInput;
        },
        change_mobile_view(view){
            if(view=='main'){
                this.$store.dispatch('setLobbyView','main');
                this.mobile_selected_type = 'prematch';
            }
            else if(view=='live'){
                this.$store.dispatch('setLobbyView','sport');
                this.mobile_selected_type = 'live';
                this.sport_selected={
                    name:"SOCCER",
                    icon:'',
                    id_live:1,
                    count:1
                };
            }
            else if(view=='prematch'){
                this.$store.dispatch('setLobbyView','sport');
                this.mobile_selected_type = 'prematch';
                this.sport_selected={
                    name:"SOCCER",
                    icon:'',
                    id_live:1,
                    count:1
                };
            }
            let data = this.$store.getters['prematch_2/getLigasArray'];
            data.forEach(liga => {
                this.$root.$emit('uncheck_liga_prematch2',liga.league);
            });
            let check_countries = document.getElementsByClassName('check_country_prematch2');
            [...check_countries].forEach(item=>{
                if(item.checked){
                    item.checked = false;
                }
            });
            this.$store.dispatch('prematch_2/remove_ligas');
            this.$store.dispatch('prematch_2/unsuscribe_all_events');
            let data2 = this.$store.getters['live/getLigasArray'];
            data2.forEach(liga => {
                this.$root.$emit('uncheck_liga_live',liga.league);
            });
            let check_countries2 = document.getElementsByClassName('check_country_live');
            [...check_countries2].forEach(item=>{
                if(item.checked){
                    item.checked = false;
                }
            });
            this.$store.dispatch('live/remove_ligas');
            this.$store.dispatch('setView','main');
        },
        set_bets(){
            this.$store.dispatch("setCanBet");
        },
        close_socket(){
            this.$store.dispatch("closeSocket");
        },
        follow(){
            this.$store.dispatch('live/setFollowId', this.follow_id);
            this.follow_id = "";
        },
        sizeControl(){
            this.screen_width=window.innerWidth;
            this.refreshHeight ++;
        },
        select_casino(target,id){
            let parameters = "";
            if(typeof target.parameters === 'object'){
                Object.keys(target.parameters).forEach(param=>{
                    parameters += "&" + param + "=" + target.parameters[param];
                })
            }
            this.casino_frame = target.url+'?token='+this.user.token+parameters;
            this.$refs.casino_navbar.classList.add('hide_options');
            document.getElementById(id).classList.add('hover');
        },
        hover1(id){
            document.getElementById(id).classList.add('hover');
        },
        hover2(id){
            document.getElementById(id).classList.remove('hover');
        },
        translate(text) {
            if (this.translation[text]) {
                return this.translation[text][this.language];
            }
            return text;
        },
        login(){
            document.getElementById('login_btn').click();
        },
        register(){
            document.getElementById('register_btn').click();
        }
    }
}
</script>

<style>
  @import '../../assets/front_ecuabets/Styles.css';
  @import '../../assets/flag-icons.css';
  /* width */
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: transparent; 
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: rgb(102, 101, 101); 
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgb(102, 101, 101);  
}
iframe{
    width: 100%;
    scroll-behavior: auto;
    /* position: absolute; */
    border: 0;
}
.cupon_button{
    position:fixed;
	width:60px;
	height:60px;
	bottom:60px;
	right:20px;
    z-index:100;
    border-radius: 50%;
}
.holds-the-iframe {
    background: url('~@/assets/front_ecuabets/images/loader2.gif') center center no-repeat;
    min-height: 200px;
    width: 100%;
    overflow-x: hidden;
    background-size: 5%; /* Tamaño predeterminado */

    @media (max-width: 767px) {
      /* Para pantallas más pequeñas, como celulares */
      background-size: 30%; /* Ajusta el tamaño como desees */
    }
  }
.float{
	position:fixed;
	width:60px;
	height:60px;
   z-index:100;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Fondo semitransparente */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3; /* Asegura que el modal esté por encima de otros elementos */
}
</style>